import React, { useEffect, useState } from "react";
import { serviceAtSalonSteps } from "../../../utils/Constants";
import { GoCheck } from "react-icons/go";
import { IoMdClose } from "react-icons/io";

const setValue = (status) => {
  switch (status) {
    case "0":
      return 1;
    case "1":
      return 2;
    case "3":
      return 3;
    case "4":
      return 4;
    case "5":
      return 5;
    default:
      return -1;
  }
};

const ProgressStep = ({ status, statusTimeStamps }) => {
  const activeStep = setValue(status);
  let timeStamps = statusTimeStamps;
  const [array, setArray] = useState([]);

  // console.log("csdcd", timeStamps);
  // console.log("statusTimeStamps", statusTimeStamps);

  useEffect(() => {
    let array = [];
    if (status === "5") {
      // array.push("pending");
      // array.push("cancelled");
      // setArray(array);
      array.push("pending");

      timeStamps?.splice(2, 1);

      timeStamps &&
        timeStamps?.map((itm, i) => {
          if (itm !== null) {
            array.push(serviceAtSalonSteps[i]);
          }
        });
      setArray(array);
    } else {
      array = serviceAtSalonSteps.slice(0, 4);
      setArray(array);
    }
  }, []);

  return (
    <>
      <div className="progressbar-container container ms-0 ps-0 py-5">
        <div className="row">
          <div className="progressBar col-12 col-lg-9 d-flex">
            {array?.map((item, i) => {
              {
                /* console.log("array", array); */
              }
              return (
                <div className="StepContainer d-flex" key={i}>
                  <div className="step">
                    {/* steps */}
                    {activeStep > i ? (
                      <div className="font16x500 progressCircle">
                        {item === "cancelled" ? <IoMdClose /> : <GoCheck />}
                      </div>
                    ) : activeStep === i ? (
                      <div className="font16x500 progressCircle">{i + 1}</div>
                    ) : (
                      <div
                        className="font16x500 progressCircle"
                        style={{ backgroundColor: "var(--border_primary)" }}
                      >
                        {i + 1}
                      </div>
                    )}

                    {/* steps label */}
                    <p
                      className="font16x500 mt-2 mb-0 text-capitalize"
                      style={{
                        color: `${activeStep < i ? "var(--text4)" : "#000"}`,
                      }}
                    >
                      {item}
                    </p>
                  </div>
                  <div
                    className="line"
                    style={{
                      // maxWidth: "200px",
                      width: "110px",
                      height: "1px",
                      backgroundColor: "var(--text4)",
                      marginTop: 15,
                    }}
                  ></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressStep;
